export default __webpack_public_path__ + "static/media/lock.8e635092.svg";